module.exports = __webpack_public_path__ + "static/img/21.90cfad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/文化娱乐/21.png
// module id = DM4B
// module chunks = 1